<script lang="ts" setup>
    import { getShippingMethodDeliveryTime } from '@shopware/helpers';
    const { isVirtualCart } = useCart();
    const { t } = useI18n();
    const { shippingMethods } = useCheckout();
    const { selectedShippingMethod: shippingMethod, setShippingMethod } = useSessionContext();
    const isLoading = reactive<{ [key: string]: boolean }>({});

    const selectedShippingMethod = computed({
        get(): string {
            return shippingMethod.value?.id || '';
        },
        async set(shippingMethodId: string) {
            isLoading[shippingMethodId] = true;
            await setShippingMethod({ id: shippingMethodId });
            isLoading[shippingMethodId] = false;
        }
    });
</script>
<template>
    <fieldset
        v-if="!isVirtualCart"
        class="info-element"
    >
        <div>
            <legend>
                <h2>
                    {{ t('checkout.shippingMethodLabel') }}
                </h2>
            </legend>
            <div>
                {{ t('checkout.selectShippingMethod') }}
            </div>
        </div>
        <div
            v-for="singleShippingMethod in shippingMethods"
            :key="singleShippingMethod.id"
            class="radio-container"
        >
            <input
                :id="singleShippingMethod.id"
                v-model="selectedShippingMethod"
                :value="singleShippingMethod.id"
                name="shipping-method"
                type="radio"
                :data-testid="`checkout-shipping-method-${singleShippingMethod.id}`"
            />
            <label
                :for="singleShippingMethod.id"
                :class="{ 'animate-pulse': isLoading[singleShippingMethod.id] }"
            >
                <div>
                    <div class="shipping-label">
                        {{ singleShippingMethod.translated?.name }}
                        <span v-if="getShippingMethodDeliveryTime(singleShippingMethod)"
                            >({{ getShippingMethodDeliveryTime(singleShippingMethod) }})</span
                        >
                        <span
                            v-if="singleShippingMethod.translated?.description"
                            class="shipping-description"
                        >
                            {{ singleShippingMethod.translated.description }}</span
                        >
                    </div>
                    <div v-if="singleShippingMethod.media?.url">
                        <img
                            loading="lazy"
                            :src="singleShippingMethod.media.url"
                            alt="payment-image"
                            aria-hidden="true"
                        />
                    </div>
                </div>
            </label>
        </div>
    </fieldset>
</template>
